import React from 'react';
import { ButtonV3 } from '@zola/zola-ui/src/components/ButtonV3';
import { BUSINESS_UNIT } from '@zola-helpers/client/dist/es/tracking/onboard/onboardTrackingConstants';
import { trackEvent } from '@zola-helpers/client/dist/es/tracking/trackingHelper';

import styles from './CardTile.module.less';

interface WebsiteTileActionsProps {
  isSelected?: boolean;
  fullWebsiteUrl?: string;
  themeLabel?: string;
  isMobileView?: boolean;
}

export const WebsiteTileActions: React.FC<WebsiteTileActionsProps> = ({
  isSelected,
  fullWebsiteUrl,
  themeLabel,
  isMobileView,
}) => {
  const handleViewDetailsClick = () => {
    trackEvent('CTA Clicked', {
      business_unit: BUSINESS_UNIT.INVITATIONS,
      cta_type: 'BUTTON',
      cta: 'PLP_SUITES_WEBSITE_VIEW_DETAILS',
    });
    window.location.href = themeLabel
      ? `/wedding/manage/website/design/${themeLabel}`
      : '/wedding/manage/website/designs';
  };

  const handleEditContentClick = () => {
    trackEvent('CTA Clicked', {
      business_unit: BUSINESS_UNIT.INVITATIONS,
      cta_type: 'BUTTON',
      cta: 'PLP_SUITES_WEBSITE_EDIT_CONTENT',
    });
    window.location.href = '/wedding/manage/website/pages/home';
  };

  const handleViewWebsiteClick = () => {
    trackEvent('CTA Clicked', {
      business_unit: BUSINESS_UNIT.INVITATIONS,
      cta_type: 'BUTTON',
      cta: 'PLP_SUITES_WEBSITE_VIEW',
    });
    window.location.href = fullWebsiteUrl || '/wedding/manage/website';
  };

  const handleTileClick = () => {
    if (isMobileView || !isSelected) {
      handleViewDetailsClick();
    } else {
      handleViewWebsiteClick();
    }
  };

  return (
    <div className={styles.cardActions} onClick={handleTileClick}>
      <div className={styles.cardDesktopActions}>
        {isSelected ? (
          <>
            <ButtonV3 variant="secondary" onClick={handleEditContentClick}>
              Edit content
            </ButtonV3>
            <ButtonV3 variant="primary" onClick={handleViewWebsiteClick}>
              View website
            </ButtonV3>
          </>
        ) : (
          <ButtonV3 variant="primary" onClick={handleViewDetailsClick}>
            View details
          </ButtonV3>
        )}
      </div>
    </div>
  );
};
